import React from 'react';
import { Navigate } from 'react-router-dom';

const ClientesListPage: React.FC = () => <Navigate to="/clientes" replace />;

export default ClientesListPage;
